<template>
  <div :class="vertical ? 'uploader-container-vertical' : 'uploader-container'">
    <div
      :style="renderImageUrl"
      :class="`${vertical ? 'image-area-vertical' : 'image-area'} ${
        uploadImage.url ? 'preview-image' : null
      }`"
      @click="onUpload"
    />

    <input
      ref="refInputEl"
      type="file"
      class="d-none"
      :accept="acceptFile.toString()"
      @change="handleUploadChange"
    />
    <div
      class="d-flex flex-wrap upload-button-container mt-1"
      :class="
        expectedWidth || expectedHight
          ? 'justify-content-between'
          : 'justify-content-end'
      "
    >
      <div v-if="expectedWidth || expectedHight">
        <div class="scale-container" v-if="expectedWidth">
          <span class="scale-label">{{ "W" }}</span>
          <span>{{ `: ${expectedWidth} pixel` }}</span>
        </div>
        <div class="scale-container" v-if="expectedHight">
          <span class="scale-label">{{ "H" }}</span>
          <span>{{ `: ${expectedHight} pixel` }}</span>
        </div>
      </div>
      <div>
        <b-button
          :pill="pillButton"
          variant="primary"
          class="upload-button"
          :class="vertical ? 'vertical-button' : null"
          @click="onUpload"
        >
          <div class="d-flex align-items-center">
            <upload-icon class="mr-3 image-upload-icon" />
            <span v-if="uploadImage.file || uploadImage.url">{{
              "Replace"
            }}</span>
            <span v-else>{{ "Upload" }}</span>
          </div>
        </b-button>
        <b-button
          :pill="pillButton"
          :disabled="!uploadImage.file && !uploadImage.url"
          :variant="
            uploadImage.file || uploadImage.url ? 'outline-danger' : null
          "
          class="upload-button ml-0 ml-sm-1"
          :class="vertical ? 'vertical-button' : null"
          @click="handleDelete"
          v-if="removable"
        >
          <span>Delete</span>
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { BButton } from "bootstrap-vue";
import UploadIcon from "@/@core/components/svg/button/Upload.vue";
//   import test from '~@/assets/css/override-styles/image-uploader.css';
import useImageUploader from "./hooks/useImageUploader";

export default {
  components: { BButton, UploadIcon },

  props: {
    imageUrl: String,
    removable: { type: Boolean, default: false },
    pillButton: { type: Boolean, default: false },
    vertical: { type: Boolean, default: false },
    expectedWidth: { type: Number },
    expectedHight: { type: Number },
    acceptFile: {
      type: [String, Array],
      default: () => [".jpg", ".jpeg", ".png"],
    },
  },

  setup(props) {
    const {
      renderImageUrl,
      uploadImage,
      handleUploadChange,
      onUpload,
      handleDelete,
    } = useImageUploader(props);

    return {
      renderImageUrl,
      uploadImage,
      handleUploadChange,
      onUpload,
      handleDelete,
    };
  },
};
</script>

<style></style>

<style scoped>
@import "~@/assets/css/override-styles/image-uploader.css";
</style>
